<template>
  <div id="azure-body">
    <div v-if="$route.meta.externo">
      <router-view  />
    </div>
    <div v-else-if="!user"> 
      <Login :interno="$route.meta.interno" :lista="lista" />
    </div>

    <div v-else-if="user && user.rp"> 
      <div class="p-3">
        <repasse-prestador :id_medico_repasse="user.id_mr" />
        <div class="mt-3">
          <button type="button" class="btn btn-outline-primary" @click="logout()">Sair</button>
        </div>
      </div>
    </div>

    <div class="p-grid" style="position:relative; min-height:100vh; margin: 0em;" v-else>

      <div class="p-col-12" :class="containerClass" @click="onWrapperClick">
        <AppTopBar ref="apptop" />

        <!-- <div :class="sidebarClass" @click="onSidebarClick">
        <div class="layout-logo">
                  <router-link to="/">
                      <img class="logo-menu" alt="Logo" src="./assets/logo.png" />
                  </router-link>
              </div>

              <AppProfile />
              <AppMenu :model="menu" @menuitem-click="onMenuItemClick" /> 
        </div>-->

        <div class="layout-main vertical-container p-2" style="margin-top: 84px; padding-bottom:2.5em">
          <!-- <az-breadcrumb></az-breadcrumb> -->
          <div style="margin-top: 15px;"></div>
          <router-view ref="modulo" />
          <perfil-paciente ref="perfil" />
          <editar-marcacao ref="editmrc" />
          <remarcar-combo ref="remarc_combo" />
          <login-pausado ref="login_pausado" />
          <relatorio-modal ref="relatmodal" />
          <open-pacs-viewer ref="pacs_viewer" />
        </div>

        <!-- <AppFooter /> -->

        <Toast :baseZIndex="99999" />

      </div>

    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import AppTopBar from "./AppTopbar.vue";
import Login from "./components/Login";
import { mapState } from "vuex";
import PerfilPaciente from './components/shared/PerfilPaciente.vue';
import EditarMarcacao from './components/modulos/callcenter/EditarMarcacao.vue';
import RepassePrestador from './components/portal/RepassePrestador.vue';
import RemarcarCombo from './components/modulos/callcenter/RemarcarCombo.vue';
import LoginPausado from './components/shared/LoginPausado.vue';
import RelatorioModal from './components/relatorios/RelatorioModal.vue';
import OpenPacsViewer from './components/modulos/laudos/OpenPacsViewer.vue';

export default {
  data() {
    return {
      layoutMode: "overlay",
      layoutColorMode: "light",
      staticMenuInactive: false,
      overlayMenuActive: true,
      mobileMenuActive: false,
      lista: [], 
      origem: null, 
    };
  },
  watch: {
    $route() {
      this.menuActive = false;
      this.$toast.removeAllGroups();
    }
  },
  methods: {
    reset_lista() { 
      this.lista = [];
    },
    
    pausar() {
      if ( this.$store.state.user.st_login ) { 
        this.lista.push(this.$store.state.user.st_login); 
        this.lista = _.uniq(this.lista).sort();
      }
       
      this.$store.commit("setUser", null);
    },

    get_origem () { 

        let origem = this.origem ? this.origem : this.$util.getCookie('origem-uuid');

        if ( !origem ) { 
            origem = this.$util.uuidv4();
            this.$util.setCookie('origem-uuid', origem, 365);
        }

        this.origem = origem; 

        return origem; 

    },

    logout() {
        let id_usuario = this.$store.state.user ? this.$store.state.user.id_usuario : null;

        console.log('Logout...', id_usuario, this.origem);

        if ( id_usuario && this.origem ) { 
            this.$util.loadItem(this, { 
                service: 'usuarios',
                func: 'logout', 
                parms: { 
                    origem: this.get_origem(),
                }
            });
        }

        this.$store.commit("setUser", null);

    },

    onWrapperClick() {
      if (!this.menuClick) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
      this.menuClick = false;
    },
    onSidebarClick() {
      this.menuClick = true;
    },
    onMenuItemClick(event) {
      if (event.item && !event.item.items) {
        this.overlayMenuActive = false;
        this.mobileMenuActive = false;
      }
    },
    addClass(element, className) {
      if (element.classList) element.classList.add(className);
      else element.className += " " + className;
    },
    removeClass(element, className) {
      if (element.classList) element.classList.remove(className);
      else
        element.className = element.className.replace(
          new RegExp(
            "(^|\\b)" + className.split(" ").join("|") + "(\\b|$)",
            "gi"
          ),
          " "
        );
    },
    isDesktop() {
      return window.innerWidth > 1024;
    }
  },
  computed: {
    containerClass() {
      return [
        /*"layout-wrapper",*/
        {
          "layout-overlay": this.layoutMode === "overlay",
          "layout-static": this.layoutMode === "static",
          "layout-static-sidebar-inactive":
            this.staticMenuInactive && this.layoutMode === "static",
          "layout-overlay-sidebar-active":
            this.overlayMenuActive && this.layoutMode === "overlay",
          "layout-mobile-sidebar-active": this.mobileMenuActive
        }
      ];
    },
    sidebarClass() {
      return [
        "layout-sidebar",
        {
          "layout-sidebar-dark": this.layoutColorMode === "dark",
          "layout-sidebar-light": this.layoutColorMode === "light"
        }
      ];
    },
    logo() {
      return this.layoutColorMode === "dark"
        ? "assets/layout/images/logo-white.svg"
        : "assets/layout/images/logo.svg";
    },
    ...mapState(["user", "isMenuVisible"])
  },
  beforeDestroy() { 
    this.logout();   
  },

  beforeUpdate() {
    if (this.mobileMenuActive)
      this.addClass(document.body, "body-overflow-hidden");
    else this.removeClass(document.body, "body-overflow-hidden");
  },
  components: {
    AppTopBar: AppTopBar,
    Login: Login,
    PerfilPaciente,
    EditarMarcacao,
    RepassePrestador, 
    RemarcarCombo, 
    LoginPausado,
    RelatorioModal, 
    OpenPacsViewer, 
  },
  mounted() { 
    window.addEventListener('online', () => this.$store.commit('setOnline', true));
    window.addEventListener('offline', () => this.$store.commit('setOnline', false));

    if ( process.env.VUE_APP_GTAG ) { 
      //this.$gtag.set({'dimension1': window.redir});
    }

    setInterval(() => { 
        if ( this.$store.state.user && this.$store.state.user.st_tipo == 'U' && this.$store.state.user.id_usuario != 1 ) { 

            const base = this.axios.defaults.baseURL;
            const redir = ( ( base.substr(0,5) == 'https' ) ? 'https://api-hb.klingo.app/api' : '' );
            const dominio = window.redir; 

            this.axios.post(redir + "/hb", 
                { 
                    idu: this.$store.state.user.id_usuario, 
                    d: dominio, 
                    o: this.get_origem() 
                })
                .then(res => {
                    if ( !res || !res.data || ( res.data.id_usuario != this.$store.state.user.id_usuario ) ) { 
                        /*
                        this.$toasted.show(
                            'Desconexão detectada.', 
                            { 
                                theme: "toasted-primary", 
                                position: "bottom-center", 
                                className: "toastnafrente",
                                containerClass: "toastnafrente",
                                action : [
                                    {
                                        text : 'Fechar',
                                        onClick : (e, toastObject) => {
                                            toastObject.goAway(0);
                                        }
                                    },
                                ]
                            }
                        );
                        */

                        // this.logout();
                    }
                })
                .catch(err => { 
                    console.log('HB: Erro ao verificar sessão...', err);
                });

        }
     }, 180000);

  }
};

//'AppProfile': AppProfile,
//'AppMenu': AppMenu,
</script>

<style scoped lang="scss">
@import "./App.scss";
.login-wrap {
  height: 100%;
  width: 100%;
}

.vertical-container {
  margin-bottom: 1em;
}

.layout-logo .logo-menu {
  max-width: 200px;
  margin: auto;
}
</style>

<!--
<style>
#azure-body { 
  background-image: url('../assets/fundo.webp');
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-size: cover;
}
</style>
-->
